import { ROUTE_NAMES } from '$router/config'
import {
  Laptop2,
  Layers,
  Lock,
  Phone,
  Shield,
  ShieldCheck,
  UserRoundCheck,
  Users2
} from 'lucide-react'
import { MENU_GROUP } from './types'
import { PERMISSIONS } from '$app/constants'

export const APP_USER_MENUS: MENU_GROUP = [
  {
    title: 'Profile',
    menus: [
      {
        Icon: Users2,
        label: 'Information',
        path: ROUTE_NAMES.GLOBAL_SERVICE_USER_DETAIL,
        permissions: []
      },
      {
        Icon: UserRoundCheck,
        label: 'Apps, Roles, Permissions, Groups',
        path: ROUTE_NAMES.GLOBAL_SERVICE_USER_APPS_ROLES_PERMISSIONS_GROUPS,
        permissions: []
      }
    ]
  },
  {
    title: 'Security',
    menus: [
      {
        Icon: Laptop2,
        label: 'Devices Login',
        path: ROUTE_NAMES.GLOBAL_SERVICE_USER_DEVICES_LOGIN,
        permissions: []
      },
      {
        Icon: Lock,
        label: 'Password Setting',
        path: ROUTE_NAMES.GLOBAL_SERVICE_USER_PASSWORD_SETTING,
        permissions: [PERMISSIONS.USER_PASSWORD_SETTING_VIEW]
      },
      {
        Icon: Shield,
        label: 'Two-Factor Authentication',
        path: ROUTE_NAMES.GLOBAL_SERVICE_USER_MFA,
        permissions: [PERMISSIONS.USER_MFA_SETTING_VIEW]
      },
      {
        Icon: Phone,
        label: 'SMS OTP',
        path: ROUTE_NAMES.GLOBAL_SERVICE_USER_SMS_OTP,
        permissions: []
      },
      {
        Icon: ShieldCheck,
        label: 'Attack Protection',
        path: ROUTE_NAMES.GLOBAL_SERVICE_USER_ATTACK_PROTECTION,
        permissions: [PERMISSIONS.USER_ATTACK_PROTECTION_VIEW]
      }
    ]
  }
]

export const DASHBOARD_USER_MENUS: MENU_GROUP = [
  {
    title: '',
    menus: [
      {
        Icon: Layers,
        label: 'Access Applications',
        path: ROUTE_NAMES.GLOBAL_MEMBER_ACCESS_APPS,
        permissions: []
      },
      {
        Icon: Users2,
        label: 'Profile',
        path: ROUTE_NAMES.GLOBAL_MEMBER_DETAIL,
        permissions: []
      }
    ]
  },
  {
    title: 'Security',
    menus: [
      {
        Icon: Lock,
        label: 'Password Setting',
        path: ROUTE_NAMES.GLOBAL_MEMBER_PASSWORD_SETTING,
        permissions: []
      }
    ]
  }
]
